import { replaceWithPlaceholders } from "@/utils/helper-functions";

// Define the month keys
export const monthKeys = [
  'month.jan',
  'month.feb',
  'month.mar',
  'month.apr',
  'month.may',
  'month.june',
  'month.july',
  'month.aug',
  'month.sep',
  'month.oct',
  'month.nov',
  'month.dec'
];

// Utility class for date-related functions
class DateUtils {
  
  // Locale translation for static texts
  cmt(getters, key, placeholders) {
    var output = getters.common_translate(key);
    return replaceWithPlaceholders(output, placeholders);
  }

  // Convert timestamp to date with localized month name
  convertTimeStampToDate(getters, timeStamp) {
    let _date = new Date(timeStamp * 1000);
    let monthIndex = _date.getMonth();
    let monthKey = monthKeys[monthIndex];
    let monthName = this.cmt(getters, monthKey);
    return `${monthName} ${_date.getDate()}, ${_date.getFullYear()}`;
  }
}

export default new DateUtils();
